import type { ComponentProps } from "react";

export function Protections(props: ComponentProps<"svg">) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 25 25"
			{...props}
		>
			<path
				stroke="currentColor"
				strokeWidth={1.5}
				d="m11.358 5.276-4.344 2.1c-.57.276-.986.806-1.062 1.434-.595 4.866 1.378 8.886 5.21 11.613a1.751 1.751 0 0 0 2.076-.036c3.713-2.822 5.506-6.627 5.386-11.415-.018-.716-.466-1.343-1.115-1.646l-4.437-2.063a2 2 0 0 0-1.714.013Z"
			/>
			<path
				fill="currentColor"
				fillRule="evenodd"
				d="M14.97 10.577a.75.75 0 0 1 .221 1.037l-2.132 3.287a1.35 1.35 0 0 1-2.075.232L9.391 13.58a.75.75 0 1 1 1.047-1.074l1.026 1a.5.5 0 0 0 .768-.086l1.7-2.622a.75.75 0 0 1 1.038-.221Z"
				clipRule="evenodd"
			/>
		</svg>
	);
}
